import axios from "axios";
const API_URL = `${process.env.REACT_APP_API_URL}/meets`;
const APP_URL = `${process.env.REACT_APP_API_URL}`
const APP_TZ_URL = `https://api.ipgeolocation.io/timezone?apiKey=${process.env.REACT_APP_TIMEZONE}`
const GMAP_GEO_URL = `https://maps.googleapis.com/maps/api/geocode/json?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
const GMAP_TZ_URL = `https://maps.googleapis.com/maps/api/timezone/json?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`

const startEventDataImport = (headerData) => {
  return axios.post(`${process.env.REACT_APP_API_URL}/imports/event_data`, {}, headerData);
};

const getEventDataImportStatus = (headerData) => {
  return axios.get(`${process.env.REACT_APP_API_URL}/imports/status`, headerData);
};

const getPastMeets = (headerData,page) => {
  return axios.get(`${API_URL}/past_meets?page=${page}&per_page=10`, headerData);
};
const getMeet = (meetID) => {
  return axios.get(`${API_URL}/${meetID}/meet`);
};
const findMeet=(headerData,meetID)=>{
  return axios.get(`${API_URL}/${meetID}/find_meet`,headerData);
}
const getCurrentMeets = (headerData) => {
  return axios.get(`${API_URL}/current_meets`, headerData)
}
const getUpcomingMeets = (headerData,page) => {
  return axios.get(`${API_URL}/upcoming_meets?page=${page}&per_page=10`, headerData);
};
const getSearchUpcomingMeets = (headerData, searchValue,pageNumber) => {
  return axios.get(`${API_URL}/upcoming_meets?meet_name=${searchValue}&page=${pageNumber}&per_page=10`, headerData);
};
const filterUpcomingMeets = (headerData, bodyData) => {
  return axios.get(`${API_URL}/upcoming_meets?city=${bodyData.city}&state=${bodyData.state}&date=${bodyData.date}&page=${bodyData.page}&per_page=10`, headerData);
};
const filterPastMeets = (headerData, bodyData) => {
  return axios.get(`${API_URL}/past_meets?city=${bodyData.city}&state=${bodyData.state}&date=${bodyData.date}&page=${bodyData.page}&per_page=10`, headerData);
};
const getSearchPastMeets = (headerData, searchValue,pageNumber) => {
  return axios.get(`${API_URL}/past_meets?meet_name=${searchValue}&page=${pageNumber}&per_page=10`, headerData);
};
const getGoverningBody = (headerData) => {
  return axios.get(`${API_URL}/governing_body_list`, headerData)
}
const getMeetTemplate = (headerData, id) => {
  return axios.get(`${API_URL}/template_list?governing_body_id=${id.governing_body_id}&state_id=${id.state_id}`, headerData)
}
const getEventList = (headerData) => {
  return axios.get(`${API_URL}/event_list`, headerData)
}
// Shared by template_event_list (classic flow) and ai_schedule_preview so both
// schedulers receive exactly the same params.
const scheduleParams = (bodyData) => {
  const fieldDataString = bodyData.field_data
    ? btoa(bodyData.field_data)
    : btoa("[]");

  const allDayTimeString = bodyData.all_day_time
    ? JSON.stringify(bodyData.all_day_time)
    : JSON.stringify([]);

  return {
    template_id: bodyData.template_id,
    governing_body_id: bodyData.governing_body_id,
    meet_time: bodyData.meet_time,
    time_zone: bodyData.time_zone,
    action_type: "create",
    field_data_b64: fieldDataString,
    all_time: allDayTimeString,
    mdbstatus: bodyData.mdbstatus,
    event_schedule: bodyData.event_schedule || "{}",
  };
};

const getTemplateEventList = (headerData, bodyData) => {
  return axios.post(`${API_URL}/template_event_list`, scheduleParams(bodyData), headerData);
};

const createMeet = (headerData, bodyData) => {
  return axios.post(`${API_URL}/create_meet`, bodyData, headerData)
}

// Reference-time suggestions for the classic flow's "missing event reference"
// modal. Standalone - no preview session, so approvals carry their own identity.
const suggestReferenceTimes = (headerData, events) => {
  return axios.post(`${API_URL}/reference_time_suggestions`, { events }, headerData);
};

const applyReferenceTimes = (headerData, approvals) => {
  return axios.post(
    `${API_URL}/reference_time_suggestions/apply`,
    { approvals },
    headerData
  );
};

const AI_PREVIEW_URL = `${API_URL}/ai_schedule_preview`;

// One shot: the same schedule params template_event_list takes (no event_list -
// the backend reads the catalog rows from template_id), plus the full meet object.
const createAiSchedulePreview = (headerData, bodyData) => {
  const payload = { ...scheduleParams(bodyData), meet: bodyData.meet, source_filename: bodyData.source_filename };
  return axios.post(AI_PREVIEW_URL, payload, headerData);
};

// A pure reload of an existing preview_id - no mutation, no AI call. Lets a
// director resume an already-generated (and possibly already-edited)
// preview instead of calling createAiSchedulePreview again from scratch.
const loadAiSchedulePreview = (headerData, previewId) => {
  return axios.get(`${AI_PREVIEW_URL}/${previewId}`, headerData);
};

// `text` is optional free-form guidance ("move the relay finals to day 2").
// Blank or omitted means a fully automatic split - the original behaviour.
const splitAiPreviewDays = (headerData, previewId, text) => {
  const body = text && text.trim() ? { text: text.trim() } : {};
  return axios.post(`${AI_PREVIEW_URL}/${previewId}/split_days`, body, headerData);
};

const proposeAiPreviewEdit = (headerData, previewId, text) => {
  return axios.post(`${AI_PREVIEW_URL}/${previewId}/nl_edit`, { text }, headerData);
};

const applyAiPreviewEdit = (headerData, previewId, pendingEditToken) => {
  return axios.post(
    `${AI_PREVIEW_URL}/${previewId}/nl_edit/apply`,
    { pending_edit_token: pendingEditToken },
    headerData
  );
};

const discardAiPreviewEdit = (headerData, previewId) => {
  return axios.post(`${AI_PREVIEW_URL}/${previewId}/nl_edit/discard`, {}, headerData);
};

// Answers a needs_clarification question from proposeAiPreviewEdit - three
// flavors, never free text. eventIndices (a director's checkbox/radio picks
// from a candidate list) and choice (one of a fixed small set, e.g. add_event's
// round type) are each omitted when not that flavor - a bare confirmation of
// the single suggestion the API already resolved (e.g. "did you mean the
// first position?") needs neither, just the token.
const answerAiPreviewClarification = (headerData, previewId, clarificationToken, eventIndices, choice, choiceLabel) => {
  const body = { clarification_token: clarificationToken };
  if (Array.isArray(eventIndices)) body.event_indices = eventIndices;
  if (choice) body.choice = choice;
  if (choiceLabel) body.choice_label = choiceLabel;
  return axios.post(`${AI_PREVIEW_URL}/${previewId}/nl_edit/clarify`, body, headerData);
};

// One AI call covers the whole needs_manual_review batch - never call per event.
const suggestAiPreviewReferences = (headerData, previewId) => {
  return axios.post(
    `${AI_PREVIEW_URL}/${previewId}/reference_suggestions`,
    {},
    headerData
  );
};

const applyAiPreviewReferences = (headerData, previewId, approvals) => {
  return axios.post(
    `${AI_PREVIEW_URL}/${previewId}/reference_suggestions/apply`,
    { approvals },
    headerData
  );
};

const confirmAiSchedulePreview = (headerData, previewId, bodyData) => {
  return axios.post(`${AI_PREVIEW_URL}/${previewId}/confirm`, bodyData, headerData);
};

// The director abandoning this preview entirely (not just discarding one
// pending edit) - actually deletes it server-side, chat history included,
// rather than leaving it to its own 1-hour TTL.
const cancelAiSchedulePreview = (headerData, previewId) => {
  return axios.post(`${AI_PREVIEW_URL}/${previewId}/cancel`, {}, headerData);
};
const createTemplate = (headerData, bodyData) => {
  return axios.post(`${API_URL}/create_template`, bodyData, headerData)
}
const updateTemplateFirstRound = (headerData, bodyData) => {
  return axios.patch(`${API_URL}/template_first_round`, bodyData, headerData)
}
const deleteTemplate = (headerData ,bodyData) => {
  return axios.delete(`${API_URL}/delete_template?id=${bodyData.template_id}`, headerData);
};
const editMeet = (headerData, bodyData, meetid) => {
  return axios.patch(`${API_URL}/${meetid}/update_meet`, bodyData, headerData)
}
const deleteMeet = (headerData, id) => {
  return axios.delete(`${API_URL}/${id}/delete_meet`, headerData)
}
const deleteEvent = (headerData, data) => {
 
  return axios.delete(`${API_URL}/events/${data.event_id}/delete_event`, headerData)
}
const getSingleEventList = (headerData, id) => {
  return axios.get(`${API_URL}/${id}/event_list`, headerData)
}
const updateEvent=(headerData,event_id,heats)=>{
   return axios.patch(`${API_URL}/events/${event_id}/update_event`,{heats:heats},headerData)
}
const getCurrentMeet = (headerData) => {
  return axios.get(`${API_URL}/current_meets`, headerData)
}
const beforeMeetEdit = (headerData, bodyData) => {
  return axios.post(`${API_URL}/template_event_list`, bodyData, headerData)
}
const afterMeetEdit = (headerData, bodyData) => {
  return axios.post(`${API_URL}/template_event_list`, bodyData, headerData)
}
const multiDayMeet = (headerData, day, page, id) => {
  return axios.get(`${API_URL}/${id}/events?page=${page}&per_page=10&day=${day}`, headerData)
}
const printMeet = (headerData,meet_id)=>{
  return axios.get(`${API_URL}/${meet_id}/print`,headerData)
}
const notificationApi = (bodyData, headerData) => {
  return axios.post(`${API_URL}/send_notification`, bodyData, headerData)
}
const meetNotificationTypes =(headerData,meet_id)=>{
  return axios.get(`${APP_URL}/notification_types?meet_id=${meet_id}`,headerData)
}
const eventNotificationTypes =(headerData,event_id)=>{
  return axios.get(`${APP_URL}/notification_types?event_id=${event_id}`,headerData)
}

const getTimeZone_api =(locvalue, domain_name)=>{
  if (domain_name == `${process.env.REACT_APP_GOOGLE_MAPS_API_URL}`) {
    let targetDate = new Date();
		let timestamp = targetDate.getTime()/1000 + targetDate.getTimezoneOffset() * 60;
    timestamp = Math.round(timestamp);
    return axios.get(`${GMAP_TZ_URL}&timestamp=${timestamp}&location=${locvalue}`)
  } else {
    return axios.get(`${APP_TZ_URL}&location=United States,${locvalue}`)
  }
}

const getLocation_api =(addrvalue)=>{
  return axios.get(`${GMAP_GEO_URL}&address=United States,${addrvalue}`)
}

const getEventListByDay = (headerData, id, day) => {
	return axios.get(`${API_URL}/${id}/events?day=${day}`, headerData);
};
const combinedMeetEvent = (headerData, bodyData) => {
	return axios.patch(`${API_URL}/combined_meet_event`, bodyData, headerData);
};

const getMeetCompletionEligibility = (headerData, meetId) => {
  return axios.get(`${API_URL}/${meetId}/completion_eligibility`, headerData);
};

const completeMeet = (headerData, meetId) => {
  return axios.patch(`${API_URL}/${meetId}/complete_meet`, {}, headerData);
};


const MeetServices = {
  getPastMeets,
  getUpcomingMeets,
  getGoverningBody,
  getMeetTemplate,
  getEventList,
  getCurrentMeets,
  getTemplateEventList,
  createMeet,
  createTemplate,
  updateTemplateFirstRound,
  getSingleEventList,
  getSearchUpcomingMeets,
  editMeet,
  deleteTemplate,
  printMeet,
  afterMeetEdit,
  deleteMeet,
  beforeMeetEdit,
  deleteEvent,
  getSearchPastMeets,
  getMeet,
  updateEvent,
  multiDayMeet,
  filterUpcomingMeets,
  filterPastMeets,
  notificationApi,
  findMeet,
  meetNotificationTypes,
  eventNotificationTypes,
  getTimeZone_api,
  getLocation_api,
  startEventDataImport,
  getEventDataImportStatus,
  getEventListByDay,
  combinedMeetEvent,
  getMeetCompletionEligibility,
  completeMeet,
  suggestReferenceTimes,
  applyReferenceTimes,
  createAiSchedulePreview,
  loadAiSchedulePreview,
  splitAiPreviewDays,
  proposeAiPreviewEdit,
  answerAiPreviewClarification,
  applyAiPreviewEdit,
  discardAiPreviewEdit,
  suggestAiPreviewReferences,
  applyAiPreviewReferences,
  confirmAiSchedulePreview,
  cancelAiSchedulePreview,
}

export default MeetServices;
